export const CLOSED_PERIODS_ADMIN_GET_LIST_INIT = 'CLOSED_PERIODS_ADMIN_GET_LIST_INIT';
export const CLOSED_PERIODS_ADMIN_GET_LIST_SUCCESS = 'CLOSED_PERIODS_ADMIN_GET_LIST_SUCCESS';
export const CLOSED_PERIODS_ADMIN_GET_LIST_FAILURE = 'CLOSED_PERIODS_ADMIN_GET_LIST_FAILURE';

export const CLOSED_PERIODS_ADMIN_SAVE_INIT = 'CLOSED_PERIODS_ADMIN_SAVE_INIT';
export const CLOSED_PERIODS_ADMIN_SAVE_SUCCESS = 'CLOSED_PERIODS_ADMIN_SAVE_SUCCESS';
export const CLOSED_PERIODS_ADMIN_SAVE_FAILURE = 'CLOSED_PERIODS_ADMIN_SAVE_FAILURE';
export const CLOSED_PERIODS_ADMIN_SET_SAVE_DATA_BY_KEY = 'CLOSED_PERIODS_ADMIN_SET_SAVE_DATA_BY_KEY';
export const CLOSED_PERIODS_ADMIN_SAVE_RESET = 'CLOSED_PERIODS_ADMIN_SAVE_RESET';

export const CLOSED_PERIODS_ADMIN_GET_CALCULATIONS_HISTORY_INIT = 'CLOSED_PERIODS_ADMIN_GET_CALCULATIONS_HISTORY_INIT';
export const CLOSED_PERIODS_ADMIN_GET_CALCULATIONS_HISTORY_SUCCESS = 'CLOSED_PERIODS_ADMIN_GET_CALCULATIONS_HISTORY_SUCCESS';
export const CLOSED_PERIODS_ADMIN_GET_CALCULATIONS_HISTORY_FAILURE = 'CLOSED_PERIODS_ADMIN_GET_CALCULATIONS_HISTORY_FAILURE';

export const CLOSED_PERIODS_ADMIN_DOWNLOAD_CALCULATION_REPORT_FILE_INIT = 'CLOSED_PERIODS_ADMIN_DOWNLOAD_CALCULATION_REPORT_FILE_INIT';
export const CLOSED_PERIODS_ADMIN_DOWNLOAD_CALCULATION_REPORT_FILE_SUCCESS = 'CLOSED_PERIODS_ADMIN_DOWNLOAD_CALCULATION_REPORT_FILE_SUCCESS';
export const CLOSED_PERIODS_ADMIN_DOWNLOAD_CALCULATION_REPORT_FILE_FAILURE = 'CLOSED_PERIODS_ADMIN_DOWNLOAD_CALCULATION_REPORT_FILE_FAILURE';

export const CLOSED_PERIODS_ADMIN_DOWNLOAD_CALCULATION_UNIFIED_REPORT_FILE_INIT = 'CLOSED_PERIODS_ADMIN_DOWNLOAD_CALCULATION_UNIFIED_REPORT_FILE_INIT';
export const CLOSED_PERIODS_ADMIN_DOWNLOAD_CALCULATION_UNIFIED_REPORT_FILE_SUCCESS = 'CLOSED_PERIODS_ADMIN_DOWNLOAD_CALCULATION_UNIFIED_REPORT_FILE_SUCCESS';
export const CLOSED_PERIODS_ADMIN_DOWNLOAD_CALCULATION_UNIFIED_REPORT_FILE_FAILURE = 'CLOSED_PERIODS_ADMIN_DOWNLOAD_CALCULATION_UNIFIED_REPORT_FILE_FAILURE';

export const CLOSED_PERIODS_ADMIN_GET_PERIODS_LIST_INIT = 'CLOSED_PERIODS_ADMIN_GET_PERIODS_LIST_INIT';
export const CLOSED_PERIODS_ADMIN_GET_PERIODS_LIST_SUCCESS = 'CLOSED_PERIODS_ADMIN_GET_PERIODS_LIST_SUCCESS';
export const CLOSED_PERIODS_ADMIN_GET_PERIODS_LIST_FAILURE = 'CLOSED_PERIODS_ADMIN_GET_PERIODS_LIST_FAILURE';

export const CLOSED_PERIODS_ADMIN_ROLL_BACK_PERIOD_INIT = 'CLOSED_PERIODS_ADMIN_ROLL_BACK_PERIOD_INIT';
export const CLOSED_PERIODS_ADMIN_ROLL_BACK_PERIOD_SUCCESS = 'CLOSED_PERIODS_ADMIN_ROLL_BACK_PERIOD_SUCCESS';
export const CLOSED_PERIODS_ADMIN_ROLL_BACK_PERIOD_FAILURE = 'CLOSED_PERIODS_ADMIN_ROLL_BACK_PERIOD_FAILURE';

export const CLOSED_PERIODS_ADMIN_DELETE_PREPARE_INIT = 'CLOSED_PERIODS_ADMIN_DELETE_PREPARE_INIT';
export const CLOSED_PERIODS_ADMIN_DELETE_INIT = 'CLOSED_PERIODS_ADMIN_DELETE_INIT';
export const CLOSED_PERIODS_ADMIN_DELETE_SUCCESS = 'CLOSED_PERIODS_ADMIN_DELETE_SUCCESS';
export const CLOSED_PERIODS_ADMIN_DELETE_FAILURE = 'CLOSED_PERIODS_ADMIN_DELETE_FAILURE';

export const CLOSED_PERIODS_GET_CUSTOMER_INIT = 'CLOSED_PERIODS_GET_CUSTOMER_INIT';
export const CLOSED_PERIODS_GET_CUSTOMER_SUCCESS = 'CLOSED_PERIODS_GET_CUSTOMER_SUCCESS';
export const CLOSED_PERIODS_GET_CUSTOMER_FAILURE = 'CLOSED_PERIODS_GET_CUSTOMER_FAILURE';

export const CLOSED_PERIODS_ADMIN_RESET = 'CLOSED_PERIODS_ADMIN_RESET';


// WEBPACK FOOTER //
// ./source/client/actions/closedPeriodsAdmin/types.js